'use es6';

import { VisualTypes } from '../schema/visual-records';
import { getReportVisualType } from '../utils/report-utils';
import { mapAreaVisual } from './visual-mappers/area-mapper';
import { mapComboVisual } from './visual-mappers/combo-mapper';
import { mapDonutToVisual } from './visual-mappers/donut-mapper';
import { mapHorizontalBarVisual } from './visual-mappers/horizontal-bar-mapper';
import { mapLineVisual } from './visual-mappers/line-mapper';
import { mapPieToVisual } from './visual-mappers/pie-mapper';
import { mapPivotVisual as mapPivotTableVisual } from './visual-mappers/pivot-table-mapper';
import { mapTableToVisual } from './visual-mappers/table-mapper';
import { mapTextToVisual } from './visual-mappers/text-mapper';
import { mapVerticalBarVisual } from './visual-mappers/vertical-bar-mapper';
import { mapScatterVisual } from './visual-mappers/scatter-mapper';
import { mapGaugeVisual } from './visual-mappers/gauge-mapper';

// map a visual + data set to a visualization using the visual mappers

export const VISUAL_MAPPERS = {
  [VisualTypes.AREA]: mapAreaVisual,
  [VisualTypes.DONUT]: mapDonutToVisual,
  [VisualTypes.HORIZONTAL_BAR]: mapHorizontalBarVisual,
  [VisualTypes.LINE]: mapLineVisual,
  [VisualTypes.SCATTER]: mapScatterVisual,
  [VisualTypes.PIE]: mapPieToVisual,
  [VisualTypes.TABLE]: mapTableToVisual,
  [VisualTypes.TEXT]: mapTextToVisual,
  [VisualTypes.VERTICAL_BAR]: mapVerticalBarVisual,
  [VisualTypes.COMBO]: mapComboVisual,
  [VisualTypes.PIVOT_TABLE]: mapPivotTableVisual,
  [VisualTypes.GAUGE]: mapGaugeVisual
};

/**
 *
 * @param {{ fiscalYearMonthName, brandKitPalettes, gates, palettes }} params
 * @returns
 */
export const visualize = (report, datasets, reportOptions, params) => {
  const visualType = getReportVisualType(report);
  const mapper = VISUAL_MAPPERS[visualType];
  return mapper(report, datasets, reportOptions, params);
};